export default __webpack_public_path__ + "static/media/banner2.7bdc81fd.jpg";